(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.ManageController = (function(superClass) {
    extend(ManageController, superClass);

    function ManageController(scope, transitions, modalInstance, service) {
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.service = service;
      this.save = bind(this.save, this);
      ManageController.__super__.constructor.apply(this, arguments);
      this.scope.resize = 0;
      this.accept = [];
      this.deny = [];
    }

    ManageController.prototype.save = function() {
      var requests;
      requests = _.filter(this.scope.requests, (function(_this) {
        return function(request) {
          return typeof request.accepted !== 'undefined';
        };
      })(this));
      return this.service.saveAdvisorRequest(requests).then((function(_this) {
        return function(response) {
          var jsr;
          jsr = response.data;
          return _this.closeWithAlert(jsr.status);
        };
      })(this));
    };

    return ManageController;

  })(DialogController);

}).call(this);
